import React, { useState, useRef, useEffect }  from 'react';
import { Row, Col, Form, Card, Alert , Button} from 'react-bootstrap';
import './FormStyles.css'; // Import the shared styles
import {variables} from '../../../Variables.json'
export const PricingTaxStock = ({ formData, updateFormData, validationErrors , onNext, onPrev }) => {
  const [charCount, setCharCount] = useState({
    hsnCode: formData.hsnCode?.length || 0
  });

  // NEW: Refs for form fields to enable auto-scrolling
  const transferPriceRef = useRef(null);
  const gstRef = useRef(null);
  const stockCountRef = useRef(null);

  // NEW: Auto-scroll to first validation error
  useEffect(() => {
    if (validationErrors && Object.keys(validationErrors).length > 0) {
      // Map of field names to their refs
      const fieldRefMap = {
        transferPrice: transferPriceRef,
        gst: gstRef,
        stockCount: stockCountRef
      };

      // Find the first error field that has a ref
      const firstErrorField = Object.keys(validationErrors).find(field => fieldRefMap[field]);
      
      if (firstErrorField && fieldRefMap[firstErrorField]?.current) {
        // Scroll to the field
        fieldRefMap[firstErrorField].current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        
        // Focus on the field after a short delay
        setTimeout(() => {
          fieldRefMap[firstErrorField].current.focus();
        }, 300);
      }
    }
  }, [validationErrors]);

  const handleStockChange = (value) => {
    // Only allow numeric values
    if (/^\d*$/.test(value)) {
      updateFormData('stockCount', value);
    }
  };

  return (
    <div className="pricing-tax-stock-tab">
      <Form>
        {/* Pricing & Tax Information */}
        <Card className="mt-1 mb-1 border-0 bg-light">
          <Card.Body className="py-1 px-2">            
            <Row className="g-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="custom-form-label">
                    Transfer Price <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    ref={transferPriceRef}
                    type="number"
                    value={formData.transferPrice || ''}
                    onChange={(e) => updateFormData('transferPrice', e.target.value)}
                    placeholder="Transfer Price to Toolsvilla (incl. GST)"
                    className={`form-control-sm custom-form-input custom-green-focus ${validationErrors?.transferPrice ? 'is-invalid' : ''}`}
                    onWheel={(e) => e.target.blur()}
                  />
                  {validationErrors?.transferPrice && (
                    <div className="invalid-feedback d-block">
                      {validationErrors.transferPrice}
                    </div>
                  )}
                  <Form.Text className="text-muted">
                    Price including GST.
                  </Form.Text>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="custom-form-label">
                    GST <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    ref={gstRef}
                    value={formData.gst || ''}
                    onChange={(e) => updateFormData('gst', e.target.value)}
                    className={`form-control-sm custom-form-input custom-green-focus ${validationErrors?.gst ? 'is-invalid' : ''}`}
                  >
                    <option value="">Click here to choose</option>
                    {variables.gstValues.map((item,index)=>{
                      return(
                        <>
                        <option key={item+index} value={item}>{item}%</option>
                        </>
                      )
                    })}
                  </Form.Select>
                  {validationErrors?.gst && (
                    <div className="invalid-feedback d-block">
                      {validationErrors.gst}
                    </div>
                  )}
                  <Form.Text className="text-muted">
                    Goods and Services Tax rate applicable
                  </Form.Text>
                </Form.Group>
              </Col>
              
              <Col xs={4}>
                <Form.Group>
                  <Form.Label className="custom-form-label">HSN Code</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.hsnCode || ''}
                    onChange={(e) => updateFormData('hsnCode', e.target.value)}
                    placeholder="Provide the Applicable 4/6/8 Digit HSN Tax Code Of Your Product"
                    maxLength="8"
                    className="form-control-sm custom-form-input custom-green-focus"
                  />
                  <Form.Text className="text-muted">
                    Harmonized System Nomenclature code
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Stock Management */}
        <Card className="mt-3 mb-3 border-0" style={{ backgroundColor: '#f8f9fa' }}>
          <Card.Body className="py-3 px-3">
            <div className="d-flex align-items-center mb-4">
              <div className="me-3" style={{ color: '#165b5b', fontSize: '1.8rem' }}>
                <i className="bi bi-box-seam"></i>
              </div>
              <div>
                <h5 className="mb-0 fw-bold" style={{ color: '#2c3e50' }}>Stock Management</h5>
                <small className="text-muted">Manage inventory levels</small>
              </div>
            </div>
            
            <Row className="align-items-center">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="custom-form-label fw-semibold">
                    Enter Stock Count <span className="text-danger">*</span>
                  </Form.Label>
                  <div className="position-relative">
                    <span className="position-absolute" style={{ left: '15px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '1.1rem', zIndex: 10 }}>
                      <i className="bi bi-box-seam"></i>
                    </span>
                    <Form.Control
                      ref={stockCountRef}
                      type="number"
                      value={formData.stockCount || ''}
                      onChange={(e) => handleStockChange(e.target.value)}
                      className={`custom-form-input custom-green-focus ${validationErrors?.stockCount ? 'is-invalid' : ''}`}
                      style={{ 
                        paddingLeft: '45px',
                        height: '45px',
                        fontSize: '1rem',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px'
                      }}
                      onWheel={(e) => e.target.blur()}
                    />
                    {validationErrors?.stockCount && (
                      <div className="invalid-feedback d-block">
                        {validationErrors.stockCount}
                      </div>
                    )}
                  </div>
                </Form.Group>
              </Col>
              
              <Col md={6}>
                <div className="d-flex align-items-center justify-content-center h-100">
                  <div className="text-center">
                    <div 
                      className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" 
                      style={{ 
                        width: '90px', 
                        height: '90px', 
                        backgroundColor: '#d1f4e0',
                        fontSize: '2.5rem'
                      }}
                    >
                      <i className="bi bi-box-seam" style={{ color: '#10b981' }}></i>
                    </div>
                    <div>
                      <div className="fw-bold" style={{ color: '#10b981', fontSize: '1.2rem' }}>
                        {formData.stockCount || 0} units available
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
      
      <div className="d-flex justify-content-between mt-2">
        <Button 
          variant="secondary" 
          onClick={onPrev} 
          size="sm"
        >
          <i className="bi bi-arrow-left me-1"></i> Previous
        </Button>
        <Button  
          style={{ 
            backgroundColor: '#165b5b',
            borderColor: '#165b5b',
            color: 'white'
          }}
          onClick={onNext} 
          size="sm"
        >
          Save & Next <i className="bi bi-arrow-right ms-2"></i>
        </Button>
      </div>

      <style jsx>{`
        /* Custom green focus styles for form inputs */
        .custom-green-focus:focus {
          border-color: #c3e6cb !important;
          outline: 0 !important;
          box-shadow: 0 0 0 0.2rem rgba(212, 237, 218, 0.5) !important;
        }
        
        .custom-green-focus:focus-visible {
          border-color: #c3e6cb !important;
          outline: 2px solid #d4edda !important;
          outline-offset: 2px;
          box-shadow: 0 0 0 0.2rem rgba(212, 237, 218, 0.5) !important;
        }
        
        /* Remove default blue focus for select dropdowns */
        select.custom-green-focus:focus {
          border-color: #c3e6cb !important;
          outline: 0 !important;
          box-shadow: 0 0 0 0.2rem rgba(212, 237, 218, 0.5) !important;
        }
        
        /* Highlight invalid fields */
        .is-invalid {
          border-color: #dc3545 !important;
        }
        
        .invalid-feedback {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 0.25rem;
        }
      `}</style>
    </div>
  );
};